import React from 'react';

export const LogoIcon = () => (
    <svg
        fill="none"
        height={128}
        viewBox="0 0 129 128"
        width={105}
        xmlns="http://www.w3.org/2000/svg"
    >
        <path
            d="M13.973 42.673v44.318c0 4.313 2.292 8.28 5.992 10.429l38.634 22.259a11.788 11.788 0 0011.802 0l38.634-22.26c3.699-2.129 5.991-6.115 5.991-10.428V42.673c0-4.314-2.292-8.281-5.991-10.41l-38.634-22.26a11.786 11.786 0 00-11.802 0l-38.634 22.26c-3.7 2.129-5.992 6.115-5.992 10.41z"
            fill="#000"
        />
        <path
            d="M64.5 13.88c1.082 0 2.165.364 3.248.91l38.616 22.205c1.985 1.092 3.249 3.276 3.249 5.642v44.408c0 2.366-1.264 4.55-3.249 5.642l-38.616 22.205c-1.083.546-2.166.91-3.248.91-1.083 0-2.166-.364-3.248-.91L22.635 92.688c-1.985-1.093-3.248-3.277-3.248-5.643V42.637c0-2.367 1.263-4.55 3.248-5.642L61.252 14.79c1.082-.546 2.165-.91 3.248-.91zm0-5.46c-1.985 0-4.15.546-5.955 1.638L19.928 32.262c-3.609 2.184-5.955 6.188-5.955 10.375v44.408c0 4.368 2.346 8.19 5.955 10.375l38.617 22.204c1.804 1.092 3.79 1.638 5.955 1.638s4.15-.546 5.955-1.638L109.07 97.42c3.79-2.184 5.955-6.189 5.955-10.375V42.637c0-4.368-2.346-8.19-5.955-10.375L70.455 10.058C68.65 8.966 66.485 8.42 64.5 8.42z"
            fill="#23D1AE"
        />
        <path
            d="M49.342 87.58h8.333V37.052h-8.333v50.526zM84.71 50.151H74.34L61.935 66.807v4.117L74.34 87.58h10.37L70.08 68.866l14.63-18.714z"
            fill="#fff"
        />
    </svg>
);
